export default "__VITE_ASSET__CTVuUv0y__"